import JsonLd from "@/components/base/JsonLd";
import Hero from "./components/Hero";
import TodayUpdates from "./components/TodayUpdates";
import Categories from "./components/Categories";
import UpdateStatus from "./components/UpdateStatus";
import Faq from "./components/Faq";
import { faqList, mangaSeries } from "@/mocks/manga";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "66漫画网",
  url: "https://897kg.cc/",
  description:
    "66漫画网专注呈现漫画更新动态，实时掌握最新话、今天更新、补更与断更等进度，帮助追更读者不再错过精彩内容。",
};

const itemListSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: mangaSeries.slice(0, 6).map((m, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: m.title,
    url: `https://897kg.cc/series/${m.id}`,
  })),
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqList.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  return (
    <>
      <JsonLd id="jsonld-org" data={organizationSchema} />
      <JsonLd id="jsonld-itemlist" data={itemListSchema} />
      <JsonLd id="jsonld-faq" data={faqSchema} />

      <Hero />
      <TodayUpdates />
      <Categories />
      <UpdateStatus />
      <Faq />
    </>
  );
}